import { Box, Typography } from '@mui/material';
import UserAvatar from 'components/UserAvatar';
import { CaptionsParticipantPayload } from 'features/transcripts/slices/captions/types';
import React from 'react';
import Icon from 'components/Icon';
import { useTranslation } from 'react-i18next';

export type CaptionsParticipantNameProps = {
  participant: CaptionsParticipantPayload | null;
  phone?: boolean;
};

export const CaptionsParticipantName = ({ participant, phone }: CaptionsParticipantNameProps) => {
  const { t } = useTranslation('room');

  if (!participant) {
    return <Typography> </Typography>;
  }

  const renderInitials = () => {
    if (phone) {
      return (
        <Icon
          name="phone"
          data-testid="phone-icon"
          sx={{
            fontSize: 26,
          }}
        />
      );
    }

    return participant.initials;
  };

  const renderName = () => {
    if (phone) {
      return t('transcripts.phone_conference_user');
    }

    return participant.name;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1 }}>
      <UserAvatar
        src={phone ? undefined : participant.avatarUrl}
        name={renderName()}
        color={participant.avatarColor || '#757575'}
        initials={renderInitials()}
        sx={{ width: 28, height: 28, fontSize: 12, mr: 4 }}
        data-testid="participant-avatar"
      />
      <Typography sx={{ fontSize: 12, color: 'grey.400' }}>{renderName()}</Typography>
    </Box>
  );
};
